import React, { useEffect, useState, } from 'react';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, } from '@voltmoney/schema';
import { Slider as SliderBase } from './Slider.base';
import ThemeProvider from '@voltmoney/theme';
import { Pressable, View, } from 'react-native';
import { Typography } from '../typography/Typography';
import { Icon } from '../icon/Icon';
import { addCommasToNumber } from '../stack/utils';
const Slider = ({ minimumValue, maximumValue, step, value, isDarkMode, onValueChangeAction, action, triggerAction, onEditIconClickAction, showSlider }) => {
    const theme = ThemeProvider.getTheme();
    const [sliderValue, setSliderValue] = useState(value);
    const [refreshPage, setRefreshPage] = useState(true);
    const onValueChange = (value) => {
        setSliderValue(value);
        triggerAction({
            ...onValueChangeAction,
            payload: {
                ...onValueChangeAction.payload,
                value,
            },
        });
    };
    useEffect(() => {
        setRefreshPage(true);
    }, []);
    useEffect(() => {
        if (!isNaN(value)) {
            setSliderValue(value);
        }
        setRefreshPage(true);
    }, [value]);
    const onSlidingComplete = (value) => {
        triggerAction({
            ...action,
            payload: {
                ...action.payload,
                value,
            },
        });
    };
    return refreshPage ? (React.createElement(View, null,
        React.createElement(View, { style: {
                justifyContent: 'center',
                marginBottom: 60,
                flexDirection: 'row',
                marginLeft: 4
            } },
            React.createElement(Typography, { id: 'txt_setCreditLimit_amount', label: '₹' + addCommasToNumber(sliderValue), fontFamily: FontFamilyTokens.Inter, fontWeight: '700', color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night, fontSize: FontSizeTokens.XXXXL }),
            React.createElement(Pressable, { nativeID: 'bt_setCreditLimit_editAmount', style: {
                    justifyContent: 'center',
                    marginLeft: 10,
                    padding: 4,
                }, onPress: () => triggerAction({
                    ...onEditIconClickAction,
                    payload: {
                        ...onEditIconClickAction.payload,
                    },
                }) },
                React.createElement(Icon, { name: IconTokens.EditBlue, size: IconSizeTokens.XXL }))),
        showSlider && React.createElement(SliderBase, { minimumValue: minimumValue, maximumValue: maximumValue, value: sliderValue, isDarkMode: isDarkMode, step: step, minimumTrackTintColor: theme.colors[ColorTokens.Primary_100], maximumTrackTintColor: '#D0D6F5', onValueChange: onValueChange, onSlidingComplete: onSlidingComplete, trackStyle: {
                height: 6,
                backgroundColor: theme.colors[ColorTokens.Primary_100],
                borderRadius: 16,
            }, thumbStyle: {
                height: 36,
                width: 36,
            }, thumbProps: {
                children: (React.createElement(Icon, { name: IconTokens.SliderIcon, size: IconSizeTokens.LG, color: ColorTokens.Primary_100 })),
            } }))) : null;
};
export default React.memo(Slider);
export { Slider };
